import React from 'react';
import { FaRobot } from 'react-icons/fa';
import { useCurrent } from '../../hooks';
import { getStatusLabel } from '../../constants/ticket';

const formatDateTime = (raw) => {
    const date = raw ? new Date(raw) : null;
    if (!date || Number.isNaN(date.getTime())) return '';
    return date.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
};

// A comment Absat Bot added by itself: a ticket's status change, shown in the conversation as a short note.
const TicketBotNote = ({ item, supportSettings }) => {
    const { currentLangId } = useCurrent();
    const isAr = currentLangId === 'ar';
    const statuses = supportSettings?.statuses;
    const from = item?.fromStatusId ? getStatusLabel(statuses, item.fromStatusId, currentLangId) : '';
    const to = getStatusLabel(statuses, item?.toStatusId || item?.statusId, currentLangId);
    const by = String(item?.changedByName || '').trim();
    const strong = (text) => <strong style={{ color: '#1e293b', fontWeight: 800 }}>{text}</strong>;

    return (
        <div
            data-testid='ticket-bot-note'
            style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 18px', fontFamily: "'Cairo', 'Segoe UI', sans-serif" }}
        >
            <div
                dir={isAr ? 'rtl' : 'ltr'}
                style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, maxWidth: '90%', padding: '6px 14px', borderRadius: 999, background: '#f8fafc', border: '1px dashed #cbd5e1', fontSize: 11.5, color: '#475569' }}
            >
                <span style={{ width: 22, height: 22, borderRadius: '50%', background: '#261759', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <FaRobot size={12} aria-hidden='true' />
                </span>
                <span style={{ fontWeight: 800, color: '#261759' }}>Absat Bot</span>
                <span>
                    {isAr ? 'تم تغيير الحالة' : 'Status changed'}
                    {from ? <> {isAr ? 'من' : 'from'} {strong(from)}</> : null}
                    {' '}{isAr ? 'إلى' : 'to'} {strong(to)}
                    {by ? <> {isAr ? 'بواسطة' : 'by'} {strong(by)}</> : null}
                </span>
                <span style={{ fontSize: 10, color: '#94a3b8', whiteSpace: 'nowrap' }}>{formatDateTime(item?.createdAt)}</span>
            </div>
        </div>
    );
};

export default TicketBotNote;
